import { render, staticRenderFns } from "./NormalNode.vue?vue&type=template&id=f761c990&scoped=true"
import script from "./NormalNode.vue?vue&type=script&lang=js"
export * from "./NormalNode.vue?vue&type=script&lang=js"
import style0 from "./NormalNode.vue?vue&type=style&index=0&id=f761c990&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f761c990",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f761c990')) {
      api.createRecord('f761c990', component.options)
    } else {
      api.reload('f761c990', component.options)
    }
    module.hot.accept("./NormalNode.vue?vue&type=template&id=f761c990&scoped=true", function () {
      api.rerender('f761c990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleFlow/src/components/NormalNode.vue"
export default component.exports